/**
 * Stripe Checkout redirect — web uses same-tab navigation; native opens
 * system browser so the user returns to the app after payment (Option B).
 */
import { isNativePlatform } from './storage';

export async function openStripeCheckout(url) {
  if (!url) return;
  if (isNativePlatform()) {
    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
      return;
    } catch (e) {
      console.warn('Capacitor Browser unavailable; falling back to same-tab redirect', e);
    }
  }
  window.location.assign(url);
}
